import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogCreatePageRoutingModule } from './blog-create-routing.module';
import { BlogCreatePage } from './blog-create.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { HeaderPageTitleBoxComponent } from '@components/headers/page-title-box/page-title-box.component';
import { ButtonModule } from 'primeng/button';
import { PlaceholderCardFormVerticalComponent } from '@components/placeholders/card-form-vertical/card-form-vertical.component';
import { InputTextModule } from 'primeng/inputtext';
import { ChipsModule } from 'primeng/chips';
import { EditorModule } from 'primeng/editor';

@NgModule({
  declarations: [
    BlogCreatePage
  ],
  imports: [
    CommonModule,
    BlogCreatePageRoutingModule,
    ReactiveFormsModule,
    RouterModule,
    BackboneComponent,
    HeaderPageTitleBoxComponent,
    ButtonModule,
    PlaceholderCardFormVerticalComponent,
    InputTextModule,
    ChipsModule,
    EditorModule
  ]
})
export class BlogCreatePageModule { }
